//举手
export const SK_INTERACT_LIST = 'sk_interact_list'
//举手添加
export const SK_INTERACT_ADD = 'sk_interact_add'
//举手查询
export const SK_INTERACT_QUERY = 'sk_interact_query'
//举手结束
export const SK_INTERACT_OVER = 'sk_interact_over'
//举手结束
export const SK_INTERACT_RES = 'sk_interact_res'
//举手编辑
export const SK_INTERACT_EDIT = 'sk_interact_edit'